import React from "react";
import Modal from "react-modal";
import "./MemecoinPageDirectionsModal.css";

Modal.setAppElement("#root");

const DirectionsModal = ({ isOpen, onRequestClose }) => {
  return (
    <Modal
      isOpen={isOpen}
      onRequestClose={onRequestClose}
      className="modal"
      overlayClassName="overlay"
    >
      <h2>Directions</h2>
      <p>1. Upload a background image using the "background image" button.</p>
      <p>2. Add feesh and lips by clicking on the respective images.</p>
      <p>3. You can drag and resize the images within the main canvas.</p>
      <p>
        4. To delete an active image, click on it to select it and then press
        the "Delete" or "Backspace" key.
      </p>
      <p>5. Click the "Clear" button to remove all added images.</p>
      <button onClick={onRequestClose} className="close-button">
        Close
      </button>
    </Modal>
  );
};

export default DirectionsModal;
